export const APP_PATHS = {
	SIGN_IN: '/sign-in',
	SIGN_UP: '/sign-up',
	FORGOT_PASSWORD: '/forgot-password',
	RESET_PASSWORD: '/password/reset/:id',
	RESET_PASSWORD_LINK: '/password/reset',
	START: '/start',
	CAR: '/car/:id',
	BOOKING_CONFIRMATION: '/booking-confirmation/:bookingId',
	PAYMENT: '/payment/:bookingId/:carId',
	CARS: '/cars/:airportSlug',
	VERIFICATION: '/verification/:id/:token/:isSupportingSms/:isSupportingCall'
};
